import PageModel from '@/models/pageModel';

export class Administrators extends PageModel {
    static moduleName = 'administrators';
    static moduleEntityName = 'administratorEntity';
    static listTitle = 'Администраторы';
    static createTitle = 'Добавление нового администратора';
    static editTitle = 'Изменение данных об администраторе';
    static apiPrefix = 'administrators';
}